import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Loader2 } from "lucide-react";
import { downloadXlsx } from "@/lib/bf";
import { fetchUsers } from "@/lib/api";

export default function BFClientExport() {
  const [agents, setAgents] = useState([]);
  const [agent, setAgent] = useState("");
  const [cat, setCat] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { fetchUsers().then((d) => setAgents(d.users.filter((u) => u.share_slug))).catch(() => {}); }, []);
  const go = () => {
    setBusy(true);
    const qs = new URLSearchParams({ agent, cat }).toString();
    downloadXlsx(`/bf/clients/export/xlsx?${qs}`, `Fise_clienti${cat ? `_${cat === "-" ? "fara_comenzi" : cat}` : ""}.xlsx`).catch(() => toast.error("Nu am putut descărca")).finally(() => setBusy(false));
  };
  return (
    <section className="invite-box" data-testid="bf-client-export">
      <h3>Descarcă fișele în Excel</h3>
      <div className="bf-smove-bar">
        <label className="st-field"><span className="st-label">Agent</span>
          <select value={agent} onChange={(e) => setAgent(e.target.value)} data-testid="bf-export-agent">
            <option value="">Toți agenții</option><option value="-">Fără agent</option>
            {agents.map((a) => <option key={a.share_slug} value={a.share_slug}>{a.name || a.email}</option>)}
          </select></label>
        <label className="st-field"><span className="st-label">Categorie</span>
          <select value={cat} onChange={(e) => setCat(e.target.value)} data-testid="bf-export-cat">
            <option value="">Toate</option><option value="A">A (5.000+ lei / 30 zile)</option><option value="B">B (3.000+ lei / 30 zile)</option><option value="C">C (500+ lei / 30 zile)</option><option value="-">Fără categorie</option>
          </select></label>
        <button type="button" className="st-btn st-btn--silver" onClick={go} disabled={busy} data-testid="bf-export-go">{busy ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />} Descarcă Excel</button>
      </div>
    </section>
  );
}
